module.exports = __webpack_public_path__ + "static/media/epa-brand.c483f94f.svg";